import type { Fallacy } from "./types";
import { createStory } from "./types";

export const sunkCost: Fallacy = {
    id: "sunk-cost",
    name: "Sunk Cost Fallacy",
    emoji: "💸",
    category: "Manipulasi Emosi & Sosial",
    description:
      "Melanjutkan sesuatu yang jelas gagal karena **sudah terlanjur keluar** banyak waktu, uang, atau usaha.",
    tldr: "Udah terlanjur keluar duit banyak bukan alasan buat terus rugi.",
    detail:
      "Sunk Cost Fallacy adalah kesalahan logika di mana seseorang melanjutkan tindakan yang merugikan karena **sudah menginvestasikan banyak waktu, uang, atau usaha** — padahal investasi itu sudah tidak bisa dikembalikan. Keputusan rasional harus didasarkan pada **prospek ke depan**, bukan pada apa yang sudah dikeluarkan.\n\nKenapa otak kita rentan? Karena kita benci rugi (loss aversion). Mengakui investasi sia-sia terasa menyakitkan, jadi kita terus bertahan.\n\nCara mengenali: Kalau saya mulai dari nol hari ini, apakah saya akan membuat keputusan yang sama? Kalau tidak, mungkin kamu terjebak sunk cost.",
    story: createStory("Sunk Cost Fallacy", "💸", {
      hook: {
        title: "Filmnya jelek banget.",
        body: "Tapi kamu tetep nonton sampai habis karena \"sayang tiketnya udah mahal.\" Logis gak sih?",
      },
      convo: {
        claim: "Kafe aku udah rugi 200 juta selama 2 tahun, kayaknya harus cut loss. Tapi temen bilang **\"udah keluar 200 juta, sayang banget kalau berhenti sekarang.\"** Jadi aku terus aja.",
        response: "200 juta itu udah gak bisa balik. **Yang bisa dicegah itu kerugian berikutnya.**",
      },
      reveal: {
        body: "Kamu terus lanjutin sesuatu yang jelas gagal karena **udah terlanjur keluar banyak**. Padahal yang udah keluar itu **gak bisa balik lagi**.",
      },
      insight: {
        title: "Kenapa otak kita gampang kena?",
        body: "Karena ngakuin investasi sia-sia itu **sakit banget**. Otak kamu lebih milih terus rugi pelan-pelan daripada ngakuin udah salah dari awal.",
      },
      engagement: {
        title: "Pernah terjebak sunk cost yang bikin nyesel?",
        body: "Bisnis, kuliah, atau hubungan? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["appeal-to-emotion", "appeal-to-tradition", "bandwagon"],
  };
